import { Skeleton } from "antd"
import React, { forwardRef, useState } from "react"

export const ApprovalDocumentPreview = forwardRef<
  HTMLDivElement,
  { pdfUrl: string }
>(({ pdfUrl }, ref) => {
  const [loading, setLoading] = useState(true)

  const getViewerUrl = (fileUrl: string) => {
    const url = new URL(pdfUrl)
    const extension = url.pathname.split(".").pop()?.toLowerCase()

    if (extension === "doc" || extension === "docx") {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`
    }

    // return `https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`
    return `${pdfUrl}#navpanes=0`
  }

  const handleLoad = () => {
    setLoading(false)
  }

  return (
    <div ref={ref} className="relative w-full h-[calc(100vh-290px)]">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Skeleton.Node className="w-full h-svh" active />
        </div>
      )}
      <iframe
        src={getViewerUrl(pdfUrl)}
        className="size-full border-0"
        title="Document Viewer"
        onLoad={handleLoad}
      />
    </div>
  )
})

ApprovalDocumentPreview.displayName = "ApprovalDocumentPreview"
